export default [
  {
    name: "debug",
    menus: [
      {
        to: "/cargo_vessel_pos",
        icon: "bars",
        title: "Cargo/Vessel Position",
      },
    ],
  },
  {
    name: "admin",
    menus: [
      {
        to: "/capt_zhao_vsl_account",
        icon: "car",
        title: "Capt. Zhao Vessel Acct",
      },
      {
        to: "/capt_zhao_transaction",
        icon: "car",
        title: "Capt. Zhao Transaction",
      },
      {
        to: "/vessel",
        icon: "car",
        title: "Vessel Management",
      },
      {
        to: "/transactions/all",
        icon: "book",
        title: "Transactions",
      },
      {
        to: "/transaction2/",
        icon: "book",
        title: "Transactions2",
      },
      {
        to: "/records",
        icon: "bars",
        title: "Records",
      },
      {
        to: "/error",
        icon: "bug",
        title: "Error",
      },
      {
        to: "/Open",
        icon: "bar-chart",
        title: "Open Position",
      },
      {
        to: "/ship_sync",
        icon: "sync",
        title: "Ship Sync",
      },
      {
        to: "/trade_profit",
        icon: "swap",
        title: "Trade Profit",
      },
      {
        to: "/voyage_pl",
        icon: "swap",
        title: "Voyage Profit & Loss",
      },
      {
        to: "/cargo_vessel_pos",
        icon: "swap",
        title: "Cargo/Vessel Position",
      },
      {
        to: "/pwd",
        icon: "swap",
        title: "Password",
      },
    ],
  },
  {
    name: "book-cashier",
    menus: [
      {
        to: "/vessel",
        icon: "car",
        title: "Vessel Management",
      },
      {
        to: "/transactions/all",
        icon: "book",
        title: "Transactions",
      },
      {
        to: "/records",
        icon: "bars",
        title: "Records",
      },
    ],
  },
  {
    name: "book-checker",
    menus: [
      {
        to: "/vessel",
        icon: "car",
        title: "Vessel Management",
      },
      {
        to: "/capt_xu_transaction",
        icon: "car",
        title: "Capt. Xu Transaction",
      },
      {
        to: "/transactions/all",
        icon: "book",
        title: "Transactions",
      },
      {
        to: "/records",
        icon: "bars",
        title: "Records",
      },
      {
        to: "/error",
        icon: "bug",
        title: "Error",
      },
    ],
  },
  {
    name: "book-keeper",
    menus: [
      {
        to: "/vessel",
        icon: "car",
        title: "Vessel Management",
      },
      {
        to: "/transactions/all",
        icon: "book",
        title: "Transactions",
      },
      {
        to: "/transaction2/",
        icon: "book",
        title: "Transactions2",
      },
      {
        to: "/voyage_pl",
        icon: "swap",
        title: "Voyage Profit & Loss",
      },
      {
        to: "/records",
        icon: "bars",
        title: "Records",
      },
      {
        to: "/pwd",
        icon: "swap",
        title: "Password",
      },
    ],
  },
  {
    name: "trader",
    menus: [
      {
        to: "/trade_profit",
        icon: "swap",
        title: "Trade Profit",
      },
    ],
  },
  {
    name: "boss",
    menus: [
      {
        to: "/voyage_pl",
        icon: "swap",
        title: "Voyage Profit & Loss",
      },
      {
        to: "/pwd",
        icon: "swap",
        title: "Password",
      },
    ],
  },
  {
    name: "intern",
    menus: [
      {
        to: "/voyage_pl",
        icon: "swap",
        title: "Voyage Profit & Loss",
      },
    ],
  },
  {
    name: "capt_zhao",
    menus: [
      {
        to: "/capt_zhao_vsl_account",
        icon: "car",
        title: "Capt. Zhao Vessel Acct",
      },
      {
        to: "/capt_zhao_transaction",
        icon: "car",
        title: "Capt. Zhao Transaction",
      },
      {
        to: "/pwd",
        icon: "swap",
        title: "Password",
      },
    ],
  },
];
